<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-11 router-view-background">
    <div class="col-md-12">
      <the-filters
        :filters="computedFilters"
        :showCleareble="showRedefine"
        @get-model="getFiltersModel"
        @on-cleareble="resetService"
        @search="searchItems"
      />
      <the-table
        id="service-list"
        :dataItems="computedServices"
        :headers="headersForTable"
      >
        <template v-slot:hStatus>
          <span class="d-flex justify-content-center">Status</span>
        </template>
        <template v-slot:status="{item}">
          <!-- <span class="d-block">{{item.status}}</span> -->
          <div style="display:flex; justify-content:center;">
          <small class="status_info" :style="`color: white; padding: 5px 10px; border-radius: 10px; background-color:${returnColorForStatus(item.status)}`">{{item.status}}</small>
          </div>
        </template>
        
        <template v-slot:countAnimals>
          <span class="d-flex justify-content-center">Animais</span>
        </template>
        <template v-slot:count_animals="{item}">
          <a 
            class="text-link" 
            style="color:var(--medium-blue) !important"
            @click="openAnimalsModal(item)"
          >{{item.service_animals_count}}</a>
        </template>

        <template v-slot:wrongAnimals>
          <span class="d-flex justify-content-center">Animais Incorretos</span>
        </template>
        <template v-slot:incorret_animals="{item}">
          <a 
            class="text-link" 
            style="color:var(--medium-blue) !important"
            @click="openAnimalsModalIncorrect(item)"
          >{{item.incorret_animals_count}}</a>
        </template>

        <template v-slot:actions="{item}">
          <b-dropdown right id="dropdown-menu-table" text="Menu" variant="menu-table" class="m-1 p-0 menu-table">           
            <b-dropdown-item v-if="isNotCreator && (item.status === 'Pendente' || item.status === 'Em preenchimento' && canCreate)"
              class="pr-5 pl-5 b-drop-options"
              @click="$router.push({name:'Edit-service', params:{id:item.id}})"
              variant="text"
            >
              <i class="mdi mdi-pencil pr-5"></i> Editar Serviço
            </b-dropdown-item>

            <b-dropdown-item
              v-if="isNotCreator"
              class="pr-5 pl-5 b-drop-options"
              @click="fieldReportModal = true, serviceToReport = item"
              variant="text"
            >
              <i class="mdi mdi-file pr-5"></i> Relatório de campo
            </b-dropdown-item>

            <b-dropdown-item
              v-if="isNotCreator"
              class="pr-5 pl-5 b-drop-options"
              @click="importPdf(item, true)"
              variant="text"
            >
              <i class="mdi mdi-file pr-5"></i> Relatório de campo (Em Branco)
            </b-dropdown-item>

            <b-dropdown-item
              v-if="isNotCreator"
              class="pr-5 pl-5 b-drop-options"
              @click="importPdfClosure(item)"
              variant="text"
            >
              <i class="mdi mdi-file pr-5"></i> Relatório de Encerramento (Em Branco)
            </b-dropdown-item>

             <b-dropdown-item
              v-if="item.status !== 'Finalizado' && item.status !== 'Classificado' && checkIfCanEditValidatedService(item) && isNotCreator"
              class="pr-5 pl-5 b-drop-options"
              @click="manageBirth(item)"
              variant="text"
            >
              <i class="mdi mdi-cake pr-5"></i> Gerenciar Partos
            </b-dropdown-item>

            <b-dropdown-item
              v-if="item.status !== 'Finalizado' && item.status !== 'Classificado' && checkIfCanEditValidatedService(item) && isNotCreator"
              class="pr-5 pl-5 b-drop-options"
              @click="$router.push({name:'Weight-in-create', params:{id:item.id}})"
              variant="text"
            >
              <i class="mdi mdi-weight pr-5"></i> Informar Pesagem
            </b-dropdown-item>

            <b-dropdown-item
              v-if="item.status === 'Finalizado' && user.attributes.kind === 'admin'"
              class="pr-5 pl-5 b-drop-options"
              @click="$router.push({name:'Weight-in-create', params:{id:item.id}})"
              variant="text"
            >
              <i class="mdi mdi-weight pr-5"></i> Validar Serviço
            </b-dropdown-item>
            
            <b-dropdown-item
              class="pr-5 pl-5 b-drop-options"
              @click="$router.push({name:'Services-details', params:{id:item.id}})"
              variant="text"
            >
              <i class="mdi mdi-printer pr-5"></i> Detalhes do Serviço
            </b-dropdown-item>

            <b-dropdown-item
              v-if="item.status === 'Validado' && checkIfHasInvalidAnimals(item) && isNotCreator"
              class="pr-5 pl-5 b-drop-options"
              @click="$router.push({name:'Weight-in-edit', params:{id:item.id}})"
              variant="text"
            >
              <i class="mdi mdi-pencil pr-5"></i> Edição de serviço validado
            </b-dropdown-item>

            <b-dropdown-item
              v-if="['Em preenchimento', 'Validado', 'Parcialmente Aprovado'].includes(item.status) && ['admin', 'partner'].includes(user.attributes.kind)"
              class="pr-5 pl-5 b-drop-options"
              @click="$router.push({name:'Milk-analysis', params:{id:item.id}})"
              variant="text"
            >
              <i class="mdi mdi-cow pr-5"></i> Análise do Leite
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canDelete(item) && isNotCreator"
              class="pr-5 pl-5 b-drop-options"
              @click="deleteServiceAlert(item)"
              variant="text"
            >
              <i class="mdi mdi-delete pr-5"></i> Deletar Serviço
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </the-table>

      <div class="col-md-12 d-flex justify-content-end">
        <v-pagination
          v-if="computedPagination ? computedPagination.total_pages > 1 : 0"
          v-model="page"
          :length="computedPagination ? computedPagination.total_pages : 0"
          color="var(--medium-blue)"
        ></v-pagination>
      </div>
    </div>

    <button-float 
      icon="mdi mdi-plus"
      :path="!checkIfCanCreateService ? 'null' : 'Services-create'"
      :class="!checkIfCanCreateService ? 'disable-button' : ''"
      v-tooltip.top="!checkIfCanCreateService ? 'Existem serviços abertos com mais de 20 dias' : ''"
      v-if="canCreate && isNotCreator"
    />

    <modal-service-animals 
      :service="dataForAnimalsModal"
      :isOpen="openModalAnimals"
      @close="openModalAnimals = false"
    />

    <modal-confirmation 
      :confirm="showConfirmation"
      :title="alertMessageTitle"
      :text="alertMessage"
      @close="showConfirmation = false"
      @save="deleteService"
    >
      <template v-slot:subText v-if="animalsWithOpenBirth.length">
        <h5 class="text-center">Parto(s)</h5>
        <ol>
        <li v-for="animal in animalsWithOpenBirth" :key="animal.animal_register">
          {{animal.animal_register}} - {{animal.animal_name}} - Data do parto: {{animal.date}}
        </li>
      </ol>
      </template>
    </modal-confirmation>

    <modal-field-report
      :isOpen="fieldReportModal"
      :service="serviceToReport"
      @close="fieldReportModal = false"
     />

    <sidebar-birth 
      :service="serviceToBirth"
      @refresh-services="loadServices"
    />
  </div>
</template>

<script>
import {BDropdown, BDropdownItem} from "bootstrap-vue";
import TheTable from "@/components/layout/TheTable";
import TheFilters from "@/components/layout/TheFilters";
import ButtonFloat from "@/components/layout/ButtonFloat";
import validations from "@/mixins/validations.js";
import helpers from "@/mixins/helpers.js";
import {mapMutations, mapState, mapActions} from "vuex";
import openAuthenticatedPdf from "@/http/openPdf";
export default {
  name:"ServicesList",
  components: {
    TheTable,
    TheFilters,
    ButtonFloat,
    BDropdown,
    BDropdownItem,
    ModalServiceAnimals: () => import("./ModalServiceAnimals.vue"),
    ModalConfirmation: () => import("@/components/layout/ModalConfirmation"),
    ModalFieldReport: () => import("./ModalFieldReport.vue"),
    SidebarBirth: () => import("@/components/adm/birth/SidebarBirth"),
  },
  mixins:[validations, helpers],
  data() {
    return {
      fieldReportModal:false,
      serviceToReport:{},
      alertMessageTitle:"",
      alertMessage:"",
      animalsWithOpenBirth:"",
      showConfirmation:false,
      serviceToDelete:{},
      serviceToBirth:{},
      headersForTable:[
        {text:"Código Serviço", value:"code", sortable:true, type:"number"},
        {text:"Status", value:"status", has_slot:true, header_slot:"hStatus", sortable:true},
        {text:"Controlador", value:"partner", sortable:true},
        {text:"Criador", value:"person", sortable:true},
        {text:"Data Pesagem", value:"date", sortable:true, type:"date"},
        {text:"Data Emissão", value:"date_emission", sortable:true, type:"date"},
        {text:"Data Confirmação", value:"date_close", sortable:true, type:"date"},
        {text:"Data Validação", value:"date_validated", sortable:true, type:"date"},
        {text:"Animais", value:"count_animals", has_slot:true, header_slot:"countAnimals", sortable:true, type:"number"},
        {text:"Animais Incorretos", value:"incorret_animals", has_slot:true, header_slot:"wrongAnimals", sortable:true, type:"number"},
        {text:"Ações", value:"actions", has_slot:true}
      ],
      query:{},
      list:[],
      page:1,
      showRedefine:false,
      openModalAnimals:false,
      dataForAnimalsModal:{}
    }
  },
  computed: {
    ...mapState("service", ["services","pagination"]),
    ...mapState("login", ["user"]),
    ...mapState("creators", ["creators"]),
    ...mapState("partners", ["partners"]),
    // perfil criador (N2): só consulta — vê os serviços das próprias fazendas, sem ações
    isNotCreator() {
      return this.user.attributes.kind !== "creator";
    },
    checkIfCanCreateService() {
      const lastServiceUnix = this.services
      .filter(service => service.status !== "Validado" && service.status !== "Finalizado")
      .reduce((lastService, currentService) => {
        this.returnUnixTimeStamp(lastService.date_emission) < this.returnUnixTimeStamp(currentService.date_emission)
        if(this.returnUnixTimeStamp(lastService.date_emission) < this.returnUnixTimeStamp(currentService.date_emission)) {
          return this.returnUnixTimeStamp(lastService.date_emission);
        } else {
         return this.returnUnixTimeStamp(currentService.date_emission)
        }
      }, 0);
      const today = Math.round(new Date().getTime() / 1000);
      if(this.user.attributes.kind === "admin") {
        return true;
      }
      else if(this.user.attributes.kind !== "admin" && this.user.roles.find(e => e.name === "service.create.twenty.days")) {
        return true;
      }
      else if(
        this.user.attributes.kind !== "admin" && 
        !this.user.roles.find(e => e.name === "service.create.twenty.days") &&
        today > (lastServiceUnix + 1728000)
      ) {
        return false;
      }
      return false
    },
    //Essa computed devolve os filtros do componente
    computedFilters() {
      let result = [
        {name:"code", type:"text", label:"Código Serviço"},
        {name:"partner", type:"select", label:"Controlador", items:this.partners},
        {name:"person", type:"select", label:"Criador", items:this.creators},
        {name:"status", type:"select", label:"Status", items:this.computedStatus},
        {name:"kind", type:"select", label:"Tipo do Serviço", items:this.computedKind},
      ];
      if(this.user.attributes.kind === 'partner') {
        result.splice(1, 1);
      }
      return result;
    },
    computedKind() {
      return [
        {name:"Controle", id:"weight"},
        {name:"Supervisão", id:"view"},
      ]
    },
    //Essa computed mapea todos os serviços na lista e pega os status
    computedStatus() {
      if(this.computedServices.length) {
        const status = this.computedServices.map(e => ({name:e.status, id:this.returnStatusId(e.status)}));
        return status
      } else return []
    },
    computedPagination() {
      if(this.pagination) {
        return this.pagination
      } 
      else {
        return false
      }
    },
    canCreate() {
      let finded = this.user.roles.find(e => e.name === "service.create");
      if(finded) {
        return true;
      } else {
        return false;
      }
    },
    computedServices: {
      get() {
        return this.services
          .map(e => ({
            ...e, 
            code:e.code,
            person:e.person.name,
            partner:e.partner.name,
            date:this.parseDate(e.date ? e.date : ""),
            date_emission:e.date_emission,
            date_close:!e.date_close.length > 0 ? e.status : e.date_close,
            count_animals:e.service_animals_count,
            incorret_animals:e.incorret_animals_count
          }));
      },
      set(newValue) {
        this.services = newValue;
      }
    }
  },
  methods: {
    ...mapActions("service", ["actionGetServices", "actionGetSingleService", "actionDeleteService"]),
    ...mapActions("creators", ["actionGetCreators"]),
    ...mapActions("partners", ["actionGetPartners"]),
    ...mapMutations("sidebar", ["SET_ACTIVE"]),
    returnUnixTimeStamp(date) {
      return Math.round(new Date(this.parseDate(date)).getTime() / 1000);
    },
    checkIfHasInvalidAnimals(service) {
      return service.incorret_animals_count > 0;
    },
    canDelete(item) {
      if(!item.close) {
        return true;
      }
      else {
        return false;
      }
    },
    deleteServiceAlert(item) {
      const animalsWithBirth = item.animal_births;
      if(animalsWithBirth.length) {
        this.alertMessageTitle = "Alerta";
        this.alertMessage = "Ao excluir este serviço, os partos abaixo serão apagados:";
        this.animalsWithOpenBirth = animalsWithBirth;
        this.showConfirmation = true;
        this.serviceToDelete = item
      } else {
        this.alertMessageTitle = "Confirmação";
        this.alertMessage = "Está é um operação irreversível, deseja continuar ?";
        this.animalsWithOpenBirth = [];
        this.showConfirmation = true;
        this.serviceToDelete = item
      }
    },
    manageBirth(item) {
      this.serviceToBirth = item;
      this.SET_ACTIVE(true);
    },
    checkIfCanEditValidatedService(item) {
      if(item.status === "Validado") {
        return false; 
      } 
      else if(item.status === "Validado" && item.incorret_animals_count > 0) {
        return false; 
      } else {
        return true;
      }
    },
    //Esse função recebe e seta os items de query de busca
    getFiltersModel(data) {
      this.query[data.title] = data.value
    },
    handleEnterKeypress(e) {
      if(e.key === "Enter" && Object.keys(this.query).length > 0) {
        this.searchItems();
      }
    },
    async loadServices(page = this.page) {
      await this.actionGetServices({...this.query, page, summary:true});
    },
    //Essa função faz o get dos items da tabela conforme os filtros
    async searchItems() {
      const {code, partner, person, status, kind} = this.query;
      if(code || partner || person || status || kind) {
        this.showRedefine = true;
        if(this.page === 1) {
          await this.loadServices(1);
        } else {
          this.page = 1;
        }
      } else {
        this.$toast.warning("Informe ao menos um filtro de pesquisa !");
      }
    },
    //Esse metodo é especifico para resetar os item iniciais de serviço
    async resetService() {
      this.query = {};
      this.showRedefine = false;
      if(this.page === 1) {
        await this.loadServices(1);
      } else {
        this.page = 1;
      }
    },
    //Esse metodo importa o pdf do serviço
    importPdf(service, blank) {
      const suffix = blank ? "?data=blank" : ""
      const url = `${process.env.VUE_APP_URL_API}/v1/services/${service.id}/pdf${suffix}`
      openAuthenticatedPdf(url).catch(() => this.$toast.error("Não foi possível abrir o PDF"))
    },
    // Formulário de encerramento de lactação em branco (sistema do Rapha)
    importPdfClosure(service) {
      const url = `${process.env.VUE_APP_URL_API}/v1/services/${service.id}/pdf_explanation`
      openAuthenticatedPdf(url).catch(() => this.$toast.error("Não foi possível abrir o PDF"))
    },
    //Esse metodo retorna a cor do status 
    returnColorForStatus(status) {
      if(status === "Em preenchimento") {
        return "#56707a" //dark grey
      }
      if(status === "Pendente") {
        return "#1f6fd1" // azul
      } 
      if(status === "Fechado") {
        return "#127a5c" // verde-azulado
      }      
      if(status === "Validado") {
        return "#2e7d32" // verde
      }
      if(status === "Classificado") {
        return "#9044eb" // purple
      }
      else {
        return "#b45f06" // laranja - Finalizado
      }
    },
    //Esse metodo vai ler e retornar o id (criado pelo front) para passar para a api na busca
    returnStatusId(status) {
      if(status === "Pendente") {
        return "pending";
      }
      if(status === "Finalizado") {
        return "close"
      }
      if(status === "Em preenchimento") {
        return "open"
      }
      if(status === "Parcialmente Aprovado") {
        return "unaproved"
      }
      if(status === "Classificado") {
        return "classified"
      }
      if(status === "Validado") {
        return "validated"
      }
    },
    //Esse metodo vai abrir o modal de animais do serviço
    async openAnimalsModal(service) {
      try {
        const details = await this.actionGetSingleService(service.id);
        this.dataForAnimalsModal = {code:details.code, animals:details.service_animals.map(e => ({...e.animal, regime:e.regime}))};
        this.openModalAnimals = true;
      } catch(error) {
        this.$toast.error(`${error}`);
      }
    },
    async openAnimalsModalIncorrect(service) {
      try {
        const details = await this.actionGetSingleService(service.id);
        this.dataForAnimalsModal = {code:details.code, animals:details.incorret_animals.map(e => ({...e.animal, regime:e.regime}))};
        this.openModalAnimals = true;
      } catch(error) {
        this.$toast.error(`${error}`);
      }
    },
    //Esse metodo deleta o serviço 
    async deleteService() {
      try {
        await this.actionDeleteService(this.serviceToDelete);
        this.serviceToDelete = {};
        this.showConfirmation = false;
      } catch(error) {
        this.$toast.error(`${error}`);
      }
    }
  },
  async mounted() {
    document.addEventListener("keypress", this.handleEnterKeypress);
    await this.loadServices(1);
    await this.actionGetCreators();
    await this.actionGetPartners();
  },
  beforeDestroy() {
    document.removeEventListener("keypress", this.handleEnterKeypress);
  },
  watch: {
    async page(val) {
      await this.loadServices(val)
    }
  }
}
</script>

<style scoped>
  .disable-button {
    opacity: 0.5;
  }
</style>
